/**
 * Step 7 — Doctrinal trust card
 *
 * Spec: specs/onboarding-rebuild.md → Act 2 step 7 (NEW 2026-05-13)
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 */

import DoctrinalTrustSynthesis from './DoctrinalTrust.synthesis'

export default function DoctrinalTrustStep({ onContinue }) {
  return <DoctrinalTrustSynthesis onContinue={onContinue} />
}
